import { connect } from 'react-redux';
import InspectionData from './InspectionData';
import { getUpdateInspectionLoader } from '../../../../store/selectors/inspection.selectors';
import { updateInspectionBegin } from '../../../../store/actions/inspection.actions';
import { setError } from '../../../../store/actions/site.actions';

const mapStateToProps = (state: any) => {
    const isLoading = getUpdateInspectionLoader(state);
    return { isLoading };
};

const mapDispatchToProps = {
    updateInspection: updateInspectionBegin,
    setError: setError,
};
export default connect(mapStateToProps, mapDispatchToProps)(InspectionData);
